import React, { Component } from 'react';
import {
  shape,
  arrayOf,
  string,
} from 'prop-types';
import classNames from 'classnames';
import styleVariables from 'styles/variables';
import { Icon } from 'components/common';
import RewardSlickPane from 'components/product/RewardSlickPane';
import ReactSlick from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './RewardSlickPanel.scss';

const slickSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  dotsClass: 'slick-dots slick-thumb',
  nextArrow: <div><Icon medium name="chevron_forward" secondary /></div>,
  prevArrow: <div><Icon medium name="chevron_previous" secondary /></div>,
  responsive: [
    {
      breakpoint: styleVariables.screenSmMax,
      settings: {
        slidesToShow: 1.33333333,
        arrows: false,
        dots: true,
      },
    },
  ],
};

class RewardSlickPanel extends Component {
  constructor(props) {
    super(props);
    this.cardBlcks = [];

    this.state = {
      height: 0,
    };
  }

  componentDidMount() {
    const height = this.getHighestHeight(this.cardBlcks);
    this.setState({
      height,
    });
  }

  // get height of highest card element
  getHighestHeight = (cards) => {
    let highest = 0;
    cards.forEach((card) => {
      let cardHeight = 0;

      Array.from(card.children).forEach((items) => {
        const style = items.currentStyle || window.getComputedStyle(items);
        cardHeight += items.clientHeight + parseInt(style.marginBottom, 10)
          + parseInt(style.marginTop, 10);
      });

      highest = highest > cardHeight
        ? highest : cardHeight;
    });
    return highest;
  };

  // populate all child card elements
  cardRef = (ref, i) => {
    this.cardBlcks[i] = ref;
  };

  render() {
    const { rewards = [], labelOption } = this.props;
    const { height } = this.state;
    const slickPanelClasses = classNames(
      'reward-slick-panel', {
        'single-item': rewards.length === 1,
      },
    );

    return (
      <div className={slickPanelClasses}>
        <ReactSlick {...slickSettings}>
          {rewards.map((reward, i) => (
            <div className="reward-slick-pane-wrapper" key={reward.title}>
              <RewardSlickPane
                index={i + 1}
                {...reward}
                labelOption={labelOption}
                cardRef={this.cardRef}
                height={height}
              />
            </div>
          ))}
        </ReactSlick>
      </div>
    );
  }
}

RewardSlickPanel.propTypes = {
  rewards: arrayOf(shape({})).isRequired,
  labelOption: string.isRequired,
};

export default RewardSlickPanel;
